// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gmQL","field":"styles_field__1_27_","fieldCol":"styles_fieldCol__31i_R","diffCol":"styles_diffCol__20jjU","diff":"styles_diff__3gshV"};